export class RescheduleEvent {
    event: string = 'reschedule';
}
